import React, { useEffect, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import BazarButton from "components/BazarButton";

const component = ({ onChangeKeyword, setSearchValue, budgetValue, value, disabled }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [searchParam, getSearchParam] = useState<string>(value || "");

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    getSearchParam(value || "");
  }, [value]);

  const onEnter = () => {
    onChangeKeyword(searchParam, budgetValue);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    getSearchParam(value);
    setSearchValue(value);

    if (value === "") {
      onChangeKeyword("", budgetValue);
      setSearchValue("");
    }
  };

  const SearchButton = (
    <InputAdornment position="end">
      <BazarButton
        variant="contained"
        color="secondary"
        sx={{
          position: "absolute",
          right: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 60,
          height: "100%",
        }}
        onClick={onEnter}
      >
        <SearchIcon />
      </BazarButton>
    </InputAdornment>
  );

  return (
    <div>
      <TextField
        disabled={disabled}
        fullWidth
        size="small"
        type="text"
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            onEnter();
          }
        }}
        value={searchParam}
        onChange={(e) => handleChange(e)}
        InputProps={{
          sx: {
            height: 44,
            borderRadius: 300,
            backgroundColor: "white",
            color: "grey.900",
            overflow: "hidden",
            border: "1px solid  #0566D2",
          },
          endAdornment: SearchButton,
        }}
        placeholder="Search Product Name or Brand"
        variant="outlined"
      />
    </div>
  );
};
export const AiBuilderSearchBar = React.memo(component);
